import { qsa } from "@fluorescent/dom";
import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  articleObserverItems: `
    .article__header,
    .article__image,
    .article__content,
    .article__content-share,
    .article__tags,
    .article__pagination,
    .article__comments
  `,
  articleHeaderItems: ".article__header > *",
  articleImage: ".article__image",
  articleContent: `
    .article__content,
    .article__content-share,
    .article__tags,
    .article__pagination,
    .article__comments
  `,
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(node, [
    selectors.articleHeaderItems,
    selectors.articleImage,
    selectors.articleContent,
  ]);

  const articleObserverItems = qsa(selectors.articleObserverItems, node);
  console.log("articleObserverItems", articleObserverItems);
  const observers = articleObserverItems.map(item => intersectionWatcher(item));

  return {
    destroy() {
      observers.forEach(observer => observer.destroy());
    },
  };
};
